import React from "react";
import { useIntl } from "react-intl";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Checkbox } from 'Components';

const MAX_HEADER_SELECTED = 7

const FilterPdfColumns = ({
    columnHeaders,
    selectedColumns,
    setSelectedColumns,
    errorStatus,
    setErrorStatus
}) => {
    const {messages} = useIntl()

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        {messages["exportVehicles_pdfMaxFiles"]}
      </AccordionSummary>
      <AccordionDetails>
        {columnHeaders?.map((header) => {
          return (
            <div
              key={header}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Checkbox 
                key={header}
                value={selectedColumns?.find((selected) => selected === header)}
                onChange={() => {
                  setErrorStatus({...errorStatus, selectedColumns: null})
                  const validate = selectedColumns?.find(
                    (selected) => selected === header
                  );
                  if (validate)
                    return setSelectedColumns(
                      selectedColumns.filter((item) => item !== header)
                    );
                  if (selectedColumns?.length === MAX_HEADER_SELECTED) return;
                  setSelectedColumns((prevValues) => [...prevValues, header]);
                }}
              />
              <p>{messages[`exportVehicles_${header}`]}</p>
            </div>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterPdfColumns;
